import { Typography } from "@material-ui/core";
import { InfoItem } from "../contacts/WatchContactPage";


export default function NBOTab({ nbo }) {

    function getValue(value, units = null) {
        return value ? `${value} ${units ? units : ''}` : '---';
    }


    const PriceSection = () => {
        return (
            <>
                <div className="d-flex align-item-center">
                    <div className="col-3">
                        <InfoItem label="Proposed Price" value={getValue(nbo?.proposedPrice, 'k€/MW')} />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Exclusivity requirement" value={nbo?.exclusivity ? 'Yes' : 'No'} />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Exclusivity requirement" value={getValue(nbo?.exclusivityMonths, 'months')} />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-3">
                        <Typography variant={"h5"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                            Payment Structure
                        </Typography>
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Upfront payment: " value={getValue(nbo?.payment?.upfront, '%')} h6 row />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Milestone payment 2: " value={getValue(nbo?.payment?.pay2, '%')} h6 row />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Milestone payment 3: " value={getValue(nbo?.payment?.pay3, '%')} h6 row />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Milestone payment 4: " value={getValue(nbo?.payment?.pay4, '%')} h6 row />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Milestone payment 5: " value={getValue(nbo?.payment?.pay5, '%')} h6 row />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Contengencies on price" value={getValue(nbo?.contingences, '%')} />
                    </div>
                    <div className="col-8">
                        <InfoItem label="Conditions for hold back" value={getValue(nbo?.conditionsHoldBack)} />
                    </div>
                </div>

            </>
        );
    }

    const TransactionStructure = () => {
        return (
            <>
                <div className="d-flex align-item-center">
                    <div className="col-6">
                        <InfoItem label="Acquiring as principal or agent for a 3rd party" value={getValue(nbo?.acquiring)} />
                    </div>
                    <div className="col-6">
                        <InfoItem label="Percentage of the company to be acquired" value={getValue(nbo?.percentAc, '%')} />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-6">
                        <Typography variant={"h5"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                            How do you finance the acquisition?
                        </Typography>
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-3">
                        <InfoItem label="Equity: " value={getValue(nbo?.financeAc?.equity, '%')} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Debt: " value={getValue(nbo?.financeAc?.debt, '%')} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Green bond: " value={getValue(nbo?.financeAc?.green, '%')} h6 row />
                    </div>
                    <div className="col-3">
                        <InfoItem label="Community financing: " value={getValue(nbo?.financeAc?.comm, '%')} h6 row />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-6">
                        <InfoItem label="Level of approval required to complete transaction" value={getValue(nbo?.levelApp)} />
                    </div>
                    <div className="col-6">
                        <InfoItem label="Timing required to complete the transaction" value={getValue(nbo?.monthsTrans, 'months')} />
                    </div>
                </div>
            </>
        );
    }

    const DueDiligence = () => {

        return (
            <>
                <div className="d-flex align-item-center">
                    <div className="col-6">
                        <InfoItem label="Time for Due Diligence" value={getValue(nbo?.monthsDueDil, 'months')} />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-6">
                        <Typography variant={"h5"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                            Do you have external advisors you will appoint?
                        </Typography>
                    </div>
                </div>
                <div className="d-flex align-item-center">
                    <div className="col-4">
                        <InfoItem label="Technical: " value={getValue(nbo?.extAd?.tech)} h6 row />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Legal: " value={getValue(nbo?.extAd?.legal)} h6 row />
                    </div>
                    <div className="col-4">
                        <InfoItem label="Financial: " value={getValue(nbo?.extAd?.financial)} h6 row />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-6">
                        <Typography variant={"h5"} style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: "12px" }}>
                            Services required
                        </Typography>
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className="col-2">
                        <InfoItem label="DSA: " value={nbo?.serv?.dsa ? 'Yes' : 'No'} h6 row />
                    </div>
                    <div className="col-2">
                        <InfoItem label="CMA: " value={nbo?.serv?.cma ? 'Yes' : 'No'} h6 row />
                    </div>
                    <div className="col-2">
                        <InfoItem label="EPC: " value={nbo?.serv?.epc ? 'Yes' : 'No'} h6 row />
                    </div>
                    <div className="col-2">
                        <InfoItem label="O&M: " value={nbo?.serv?.om ? 'Yes' : 'No'} h6 row />
                    </div>
                    <div className="col-2">
                        <InfoItem label="AM: " value={nbo?.serv?.am ? 'Yes' : 'No'} h6 row />
                    </div>
                </div>

            </>
        )
    }


    return (
        <>
            <PriceSection />
            <div style={{ borderBottom: '2px dashed gray', marginTop: '30px', marginBottom: "30px" }} />
            <TransactionStructure />
            <div style={{ borderBottom: '2px dashed gray', marginTop: '30px', marginBottom: "30px" }} />
            <DueDiligence />
            <div style={{ borderBottom: '2px dashed gray', marginTop: '30px', marginBottom: "30px" }} />
            <div className="d-flex align-item-center">
                <div className="col-6">
                    <InfoItem label="Observations" value={getValue(nbo?.observations)} />
                </div>
            </div>


        </>
    )

}